import windows from './windows'
import linux from './linux'
import android from './android'
import ubuntu from './ubuntu'

export default { windows, linux, android, ubuntu }
